//DOCS
//https://www.npmjs.com/package/vue-apexcharts
//https://apexcharts.com/docs

import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'

Vue.component('apexchart', VueApexCharts);